t = require('app/scripts/views/internal/teacup-with-helpers')('board_menu_vis')
{ featureFlagClient } = require '@trello/feature-flag-client'

module.exports = t.renderable ({ current, isNewBoard, canChange, mustChange,
  hasSuperAdmins, hasOrg, orgName, privateRestricted, orgRestricted,
  enterpriseRestricted, publicRestricted, hasEnterprise, enterpriseName, isTemplate }) ->

  if mustChange && orgName
    t.p '.quiet', ->
      t.format 'illegal org visibility', { orgName }
  orgLevel = if hasEnterprise
    'with enterprise'
  else if hasSuperAdmins
    'with super admins'
  else if hasOrg
    'with organization'
  else
    'without organization'

  permissionLevels =
    'private':
      iconClass: 'icon-private'
      restricted: privateRestricted
      invalid: isTemplate
    'org':
      iconClass: 'icon-organization'
      restricted: orgRestricted
      invalid: isNewBoard && !hasOrg
    'enterprise':
      iconClass: 'icon-enterprise'
      restricted: hasEnterprise && enterpriseRestricted
      noEnterprise: !hasEnterprise
      invalid: isNewBoard && !hasOrg
    'public':
      iconClass: 'icon-public'
      restricted: publicRestricted

  for permissionLevel, { restricted, invalid, iconClass, noEnterprise } of permissionLevels
    t.li ->
      disabled = restricted || invalid || !canChange || noEnterprise
      t.a '.js-select', { class: t.classify('disabled': disabled), href: '#', name: permissionLevel }, ->
        t.span '.icon-sm.vis-icon', { class: iconClass }, ->
        t.check current == permissionLevel, permissionLevel
        t.span '.sub-name', ->
          args = if enterpriseName
            { enterpriseName, orgName }
          else if orgName
            { orgName }
          else
            {}

          templateSubtext = if isTemplate then 'is template ' else ''
          t.format ['permission subtext', "#{templateSubtext}#{orgLevel}", permissionLevel], args

          if canChange && restricted
            t.raw ' '
            t.span '.error', ->
              if isNewBoard
                t.format ['illegal visibility', 'create']
              else
                t.format ['illegal visibility', 'change']
